import React, { forwardRef } from 'react';
import { Autocomplete, Avatar, Box, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { PersonOutline } from '@mui/icons-material';
import { BRAND_COLOR, FieldLabel } from './FormSection';

const getInitials = (name = '') =>
  name
    .replace(/^(dr|dra)\.?\s+/i, '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

const InstructorInfo = forwardRef(({
  capacitadores,
  teacherValue,
  onTeacherChange,
  error
}, ref) => (
  <Box ref={ref}>
    <FieldLabel error={error}>Capacitador</FieldLabel>
    <Autocomplete
      options={capacitadores || []}
      getOptionLabel={(option) => option?.nombre || ''}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      freeSolo
      value={teacherValue || null}
      onChange={(_, newValue) => onTeacherChange(newValue)}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box component="li" key={key} {...optionProps}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar sx={{ width: 32, height: 32, fontSize: 13, bgcolor: `${BRAND_COLOR}26`, color: BRAND_COLOR }}>
                {getInitials(option.nombre)}
              </Avatar>
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  {option.nombre}
                </Typography>
                {option.especialidad && (
                  <Typography variant="caption" color="text.secondary">
                    {option.especialidad}
                  </Typography>
                )}
              </Box>
            </Stack>
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Busca y selecciona el capacitador"
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                {teacherValue?.nombre ? (
                  <Avatar sx={{ width: 28, height: 28, fontSize: 12, bgcolor: BRAND_COLOR }}>
                    {getInitials(teacherValue.nombre)}
                  </Avatar>
                ) : (
                  <PersonOutline color="action" />
                )}
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              '&.Mui-focused fieldset': { borderColor: BRAND_COLOR },
            },
          }}
        />
      )}
    />
  </Box>
));

export default InstructorInfo;
